
<router-outlet (activate)="onActivate($event)"></router-outlet>
<div *ngIf="router.url != '/'" id="particle-canvas" style="display: none;"></div>